var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-select",
    _vm._b(
      { attrs: { value: _vm.value }, on: { input: _vm.onInput } },
      "el-select",
      _vm.$attrs,
      false
    ),
    _vm._l(_vm.options, function ({ value, label, inDoNotContact }) {
      return _c(
        "el-option",
        {
          key: value,
          attrs: { label: label, value: value, disabled: inDoNotContact },
        },
        [
          inDoNotContact
            ? _c(
                "el-tooltip",
                {
                  attrs: {
                    effect: "light",
                    content: "Do Not Contact feature restriction",
                    placement: "top-start",
                  },
                },
                [
                  _c("span", { staticClass: "text-danger cursor-default" }, [
                    _c("i", { staticClass: "fas fa-user-slash" }),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v("\n        " + _vm._s(label) + "\n    "),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }